import { logWrapper } from '../../utils';

export default {
  shareDocumentsController: [
    'runtimeConstant',
    '$scope',
    'authService',
    'userCrudService',
    'roleCrudService',
    'shareRevisionService',
    'revisions',
    function (
      runtimeConstant,
      $scope,
      authService,
      userCrudService,
      roleCrudService,
      shareRevisionService,
      revisions
    ) {
      'use strict';

      function userPermission(value) {
        if (arguments.length > 0) {
          $scope.currentUser = value;
        } else {
          return $scope.currentUser;
        }
      }

      function removeShare(revisionShared) {
        var index = $scope.sharedList.indexOf(revisionShared);
        $scope.sharedList.splice(index, 1);
      }

      function editPermissionsToggled(open, revisionShared) {
        if (!open) {
          var roles = revisionShared.roles.filter(function (f) {
            return f.selected === true;
          });
          if (roles.length === 0) {
            var index = $scope.sharedList.indexOf(revisionShared);

            $scope.sharedList.splice(index, 1);
          } else {
            var removed = revisionShared.roles.filter(function (f) {
              return f.selected === false;
            });
            var existingRoles = [];

            revisionShared.revisionRoles.forEach(function (r) {
              r.roles.forEach(function (role) {
                existingRoles.push(role);
              });
            });

            var newRoles = roles.filter(function (r) {
              return (
                existingRoles.some(function (c) {
                  return r.id === c.id;
                }) === false
              );
            });
            var removedRoles = removed.filter(function (r) {
              return (
                existingRoles.some(function (c) {
                  return r.id === c.id;
                }) === true
              );
            });

            if (newRoles.length > 0 || removedRoles.length > 0) {
              var idx = $scope.sharedList.indexOf(revisionShared);

              var newone = {
                sender: {
                  id: $scope.loggedUser.id,
                  name: $scope.loggedUser.name,
                },
                reciever: revisionShared.reciever,
                roles: revisionShared.roles,
                revisionRoles: revisions.map(function (r) {
                  return {
                    revision: r,
                    roles: revisionShared.roles.filter(
                      (r) => r.selected === true
                    ),
                  };
                }),
                sharedDate: null,
              };

              $scope.sharedList.splice(idx, 1);
              $scope.sharedList.push(newone);
            }
          }
        }
      }

      function permissionsToggled(open) {
        if (!open) {
          $scope.addUser();
        }
      }

      function setRevisionRoles(sharedRevision) {
        for (var x = 0, siz = $scope.roles.length; x < siz; x++) {
          var role = $scope.roles[x];

          if (
            sharedRevision.roles.filter(function (c) {
              return c.id === role.id;
            }).length === 0
          ) {
            sharedRevision.roles.push({
              id: role.id,
              name: role.name,
              selected: false,
            });
          }
        }
      }

      function addUser() {
        if ($scope.currentUser !== undefined && $scope.currentUser !== null) {
          var currentUser = $scope.currentUser;
          var selectedRoles = $scope.roles.filter(function (r) {
            return r.selected === true;
          });

          if (selectedRoles.length === 0) {
            return;
          }

          //Desselect all
          $scope.roles.forEach(function (r) {
            r.selected = undefined;
          });
          $scope.currentUser = null;

          var neo = {
            sender: {
              id: $scope.loggedUser.id,
              name: $scope.loggedUser.name,
            },
            reciever: { id: currentUser.id, name: currentUser.name },
            roles: selectedRoles.map(function (r) {
              return { id: r.id, name: r.name, selected: true };
            }),
            revisionRoles: revisions.map(function (r) {
              return {
                revision: r,
                roles: selectedRoles.map(function (r) {
                  return r;
                }),
              };
            }),
            sharedDate: null,
          };

          $scope.setRevisionRoles(neo);

          $scope.sharedList.push(neo);
        }
      }

      function clone(obj) {
        if (null === obj || 'object' !== typeof obj || Array.isArray(obj)) {
          if (Array.isArray(obj)) {
            var array = [];

            for (var i = 0, len = obj.length; i < len; i++) {
              array.push($scope.clone(obj[i]));
            }

            return array;
          }

          return obj;
        }
        var copy = obj.constructor();

        for (var attr in obj) {
          if (obj.hasOwnProperty(attr)) {
            copy[attr] = $scope.clone(obj[attr]);
          }
        }

        return copy;
      }

      function loadSharedRevisions() {
        shareRevisionService
          .loadByRevision(revisions)
          .then(function (sharedRevisions) {
            var sharedList = [];

            for (var i = 0, len = sharedRevisions.length; i < len; i++) {
              var sr = sharedRevisions[i];

              //Clona pra comparar depois na hora de salvar
              $scope.originalList.push($scope.clone(sr));

              sr.roles = [];

              sr.revisionRoles.forEach(function (rr) {
                rr.roles.forEach(function (r) {
                  r.selected = true;
                  if (
                    !sr.roles.some(function (x) {
                      return x.id === r.id;
                    })
                  ) {
                    sr.roles.push(r);
                  }
                });
              });

              if ($scope.roles !== null) {
                $scope.rolesUpdated = true;
                $scope.setRevisionRoles(sr);
              }

              sharedList.push(sr);
            }

            $scope.sharedList = sharedList;
            $scope.loading =
              $scope.users === null ||
              $scope.roles === null ||
              $scope.sharedList === null;
          });
      }

      function availableUsers() {
        if ($scope.users === null) {
          return null;
        }

        var recievers = $scope.sharedList.map(function (s) {
          return s.reciever.id;
        });

        recievers.push($scope.loggedUser.id);

        var users = $scope.users.filter(function (u) {
          return recievers.indexOf(u.id) === -1;
        });

        return users;
      }

      function loadUsers() {
        var first = revisions[0];

        userCrudService.allByCompany(first.idFolder).then((users) => {
          $scope.users = users;

          // is loading
          $scope.loading =
            $scope.users === null ||
            $scope.roles === null ||
            $scope.sharedList === null;
        });
      }

      function loadRoles() {
        var setRoles = function (roles) {
          $scope.roles = roles;

          if ($scope.sharedList !== null && $scope.rolesUpdated === false) {
            $scope.sharedList.forEach(function (sr) {
              $scope.setRevisionRoles(sr);
            });
            $scope.rolesUpdated = true;
          }

          // is loading
          $scope.loading =
            $scope.users === null ||
            $scope.roles === null ||
            $scope.sharedList === null;
        };

        if (authService.isAdmin()) {
          roleCrudService.list().then(setRoles);
        } else {
          var first = revisions[0];
          roleCrudService.listFolderRoles(first.idFolder).then(setRoles);
        }
      }

      function getRemovedShares() {
        var removedShares = [];

        for (var i = 0, len = $scope.originalList.length; i < len; i++) {
          var sh = $scope.originalList[i];

          var exist = $scope.sharedList.filter((s) => {
            return s.reciever.id === sh.reciever.id && s.sharedDate !== null;
          })[0];

          if (!exist) {
            sh.revisionRoles.forEach(() => {
              var rev = Array.isArray(revisions) ? revisions[0] : revisions;

              var item = {
                IdRevision: rev.id,
                IdUserReceiver: sh.reciever.id,
                UserReceiver: { id: sh.reciever.id, name: sh.reciever.name },
                IdUserSender: sh.sender.id,
                IdFolder: rev.idFolder,
              };
              if (
                removedShares.some((e) => {
                  return (
                    e.IdRevision === item.IdRevision &&
                    e.IdUserReceiver === item.IdUserReceiver &&
                    e.UserSender === item.UserReceiver &&
                    e.IdUserSender === item.IdUserSender &&
                    e.IdFolder === item.IdFolder
                  );
                }) === false
              ) {
                removedShares.push(item);
              }
            });
          }
        }

        return removedShares;
      }

      function getNewShares() {
        var lstShared = {};
        var added = $scope.sharedList.filter((sh) => {
          return sh.sharedDate === null;
        });
        if (added.length === 0) return lstShared;
        lstShared.idUserSender = added[0].sender.id;
        lstShared.revisions = added
          .map((sr) => sr.revisionRoles.map((rr) => rr.revision.id))
          .flat()
          .filter((value, index, self) => self.indexOf(value) === index);
        lstShared.shares = {};
        added.forEach((item) => {
          let idUserReceiver = item.reciever.id;
          if (!lstShared.shares[idUserReceiver])
            lstShared.shares[idUserReceiver] = [];
          lstShared.shares[idUserReceiver] = lstShared.shares[
            idUserReceiver
          ].concat(
            item.revisionRoles.map((rr) => rr.roles.map((r) => r.id)).flat()
          );
        });

        Object.keys(lstShared.shares).forEach((k) => {
          lstShared.shares[k] = lstShared.shares[k].filter(
            (value, index, self) => self.indexOf(value) === index
          );
        });

        return lstShared;
      }

      function save() {
        $scope.loading = true;

        var lstRemoved = $scope.getRemovedShares();
        var lstShareds = $scope.getNewShares();
        shareRevisionService
          .removeShared(lstRemoved)
          .then(() => {
            if (lstShareds.revisions) {
              shareRevisionService
                .save(lstShareds)
                .then(() => {
                  $scope.$close(true);
                })
                .catch((err) => err);
            }
            $scope.$close(true);
          })
          .catch((err) => err);
      }

      function init() {
        $scope.loggedUser = authService.user;
        $scope.loadUsers();
        $scope.loadRoles();
        $scope.loadSharedRevisions();
      }

      function run() {
        try {
          $scope.currentUser = null;
          $scope.loggedUser = null;
          $scope.users = null;
          $scope.roles = null;
          $scope.loading = true;
          $scope.rolesUpdated = false;
          $scope.sharedList = null;
          $scope.originalList = [];

          $scope.userPermission = logWrapper(
            userPermission,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.removeShare = logWrapper(
            removeShare,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.editPermissionsToggled = logWrapper(
            editPermissionsToggled,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.permissionsToggled = logWrapper(
            permissionsToggled,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setRevisionRoles = logWrapper(
            setRevisionRoles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addUser = logWrapper(
            addUser,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.clone = logWrapper(
            clone,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadSharedRevisions = logWrapper(
            loadSharedRevisions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.availableUsers = logWrapper(
            availableUsers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadUsers = logWrapper(
            loadUsers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadRoles = logWrapper(
            loadRoles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getRemovedShares = logWrapper(
            getRemovedShares,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getNewShares = logWrapper(
            getNewShares,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.init = logWrapper(
            init,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
